import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequsetForm.XeroContactAddressSearchPopup.Content', {
    title: 'Contact address',
    button: 'Use this address',
    contactDropdownPlaceholder: 'Select a Contact',
    emptyListPlaceholderTitle: 'Please select a Contact',
    emptyListPlaceholder: "You'll see a list of related addresses.",
});
